// 简单的事件总线实现
const listeners: ((message: any) => void)[] = [];

export const errorBus = {
    subscribe: (callback: any) => {
        listeners.push(callback);
        // 返回取消订阅函数
        return () => {
            const index = listeners.indexOf(callback);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    },
    notify: (res: any) => {
        console.warn("error handle:", res)
        listeners.forEach(callback => callback(res.message));
    }
};